import { FdicState } from "@/shared/types";
import { defineStore } from "pinia";
import _ from "lodash";
import { useFeatureFlagStore } from "./featureFlag";
import { useCustodianSettingsStore } from "./custodianSettings";

export const initialState: FdicState = {
  forceHideFdic: false,
  routeHideFdic: false
};

export const useFdicStore = defineStore("fdicStore", {
  state: () => (_.cloneDeep(initialState)),
  getters: {
    showFdic: state => {
      const featureFlagStore = useFeatureFlagStore();
      const custodianSettingsStore = useCustodianSettingsStore();
      return featureFlagStore.flags.bend22299Fdic
        && !state.routeHideFdic
        && !state.forceHideFdic
        && custodianSettingsStore.displayFdicBanner;
    }
  },
  actions: {
    setForceHideFdic (forceHideFdic: boolean) {
      this.forceHideFdic = forceHideFdic;
    },
  }
});